import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import Icon from 'oxyrion-ui/lib/Icon';
import moment from 'moment';
import Loader from 'oxyrion-ui/lib/Loader';
import { connect, actions } from '../../../../Store';
import AlertPopup from '../../../../Components/AlertPopup';
import {
  __,
  FORMAT_HUMANE_DATETIME,
  getIdFromProps,
  formatDate,
  getOrderStatusByCode,
  formatPrice,
} from '../../../../Utils';
import { LoaderWrapper } from '../../../../Components/ReusableComponents';
import ErrorMessage from '../../../../Components/ErrorMessage';
import OrderRows from '../Rows';
import API2 from '../../../../API2';

const Row = styled.div`
  margin-bottom: ${rem(24)};
  display: flex;
  justify-content: space-between;
`;

const Spacer = styled.div`
  width: ${props => rem(props.space)};
  height: ${props => rem(props.space)};
`;

const MainContainer = styled.div`
  padding: ${rem(16)};
`;

const PartWrapper = styled.div`
  margin-right: ${rem(40)};
`;

const PartTitle = styled.div`
  font-size: ${rem(18)};
  margin-bottom: ${rem(8)};
  font-weight: bold;
  text-decoration: underline;
`;

const PartTextBold = styled.div`
  font-size: ${rem(14)};
  font-weight: bold;
`;

const PartTextLite = styled.div`
  font-size: ${rem(14)};
`;

const PartTextLineRow = styled.div`
  display: flex;
`;

const HeaderWrapper = styled.div`
  border-bottom: ${rem(1)} solid;
  margin-bottom: ${rem(24)};
`;

const DownloadPDFWrapper = styled.div`
  font-size: ${rem(14)};
  cursor: pointer;
  margin-bottom: ${rem(12)};
  text-align: center;
  align-items: center;
  display: flex;
  :hover {
    text-decoration: underline;
  }
`;

const CopyWrapper = styled(DownloadPDFWrapper)``;

class OrderDetail extends React.Component {
  state = {
    productLoading: true,
    orderData: {},
    totalPrice: 0,
    totalPriceVat: 0,
    vat: 0,
    vatRate: 0,
  };

  async componentDidMount() {
    const id = getIdFromProps(this.props);
    await this.fetchOrder(id);

    actions.setActiveMenuItem('49');
  }

  async onPdfClick(orderId) {
    try {
      this.setState({
        pdfLoading: true,
      });
      const downloadId = await API2.getB2BOrderInvoiceAction(orderId);
      window.location = downloadId.url;
      this.setState({
        pdfLoading: false,
      });
    } catch (e) {
      this.setState({
        error: __('Nepodarilo sa načítať PDF objednávky'),
        pdfLoading: false,
      });
    }
  }

  async fetchOrder(id) {
    try {
      const orderData = await API2.getB2BOrderAction(id);

      let totalPrice = 0;

      orderData.SalesLines.WS_Sales_Order_Line.forEach(s => {
        totalPrice += Number(s.Line_Amount);
      });

      const totalPriceVat = totalPrice * (Number(orderData.vat_rate) / 100 + 1);
      const vat = totalPriceVat - totalPrice;

      this.setState({
        productLoading: false,
        totalPriceVat,
        vat,
        totalPrice,
        orderData,
        vatRate: orderData.vat_rate,
      });
    } catch (e) {
      this.setState({
        error: __('Nepodarilo sa načítať objednávku'),
      });
    }
  }

  async createCartFromOrder(orderId) {
    this.setState({
      copyOrderLoading: true,
    });

    try {
      await API2.postB2BOrderDuplicateAction(orderId);

      this.setState({
        copyOrderLoading: false,
        success: true,
      });
    } catch (e) {
      this.setState({
        copyOrderLoading: false,

        error: __('Nepodarilo sa vytvoriť kópiu objednávky'),
      });
    }
  }

  render() {
    const {
      productLoading,
      orderData,
      totalPrice,
      totalPriceVat,
      vat,
      vatRate,
      pdfLoading,
      copyOrderLoading,
      success,
      error,
    } = this.state;

    const o = orderData;

    if (productLoading) {
      return (
        <LoaderWrapper>
          <Loader size="xl" color="#70af00" />
        </LoaderWrapper>
      );
    }

    return (
      <MainContainer>
        <ErrorMessage display={error} text={error} />
        <AlertPopup
          display={success}
          alignUnderHeader
          text={__('Kópia objednávky bola vytvorená')}
          subText={__('Prajete si prejsť do košíka?')}
          success
          onSubmit={() => this.props.history.push('/shopping-cart')}
          onClose={() =>
            this.setState({
              success: false,
            })
          }
        />
        <HeaderWrapper>
          <Row>
            <div style={{ display: 'flex' }}>
              <PartWrapper>
                <PartTitle>{__('Dodávateľ')}</PartTitle>
                <PartTextBold>Dejmark spol. s.r.o</PartTextBold>
                <PartTextBold>Priekopska 3706/104</PartTextBold>
                <PartTextBold>036 01 Martin</PartTextBold>
                <PartTextLineRow>
                  <PartTextLite>ICO:</PartTextLite>
                  <Spacer space={4} />
                  <PartTextBold>31628079</PartTextBold>
                </PartTextLineRow>
                <PartTextLineRow>
                  <PartTextLite>IC DPH:</PartTextLite>
                  <Spacer space={4} />
                  <PartTextBold>SK2020434361</PartTextBold>
                </PartTextLineRow>
              </PartWrapper>

              <PartWrapper>
                <PartTitle>{__('Faktúračná adresa')}</PartTitle>
                <PartTextBold>
                  {o.Bill_to_Contact || o.Bill_to_Name}
                </PartTextBold>
                <PartTextBold>{o.Bill_to_Name}</PartTextBold>
                <PartTextBold>{o.Bill_to_Address}</PartTextBold>
                <PartTextBold>{`${o.Bill_to_Post_Code} ${
                  o.Bill_to_City
                }`}</PartTextBold>

                <PartTextLineRow>
                  <PartTextLite>ICO:</PartTextLite>
                  <Spacer space={4} />
                  <PartTextBold>{o.Registration_No}</PartTextBold>
                </PartTextLineRow>
                <PartTextLineRow>
                  <PartTextLite>IC DPH:</PartTextLite>
                  <Spacer space={4} />
                  <PartTextBold>{o.VAT_Registration_No}</PartTextBold>
                </PartTextLineRow>
              </PartWrapper>

              <PartWrapper>
                <PartTitle>{__('Adresa doručenia')}</PartTitle>
                <PartTextBold>
                  {o.Ship_to_Contact || o.Ship_to_Name}
                </PartTextBold>
                <PartTextBold>{o.Ship_to_Name}</PartTextBold>
                <PartTextBold>{o.Ship_to_Address}</PartTextBold>
                <PartTextBold>{`${o.Ship_to_Post_Code} ${
                  o.Ship_to_City
                }`}</PartTextBold>
              </PartWrapper>
            </div>
            <PartWrapper>
              <DownloadPDFWrapper onClick={() => this.onPdfClick(o.No)}>
                {pdfLoading ? <Loader /> : <Icon name="pdf" size="l" />}
                <Spacer space={4} />
                {__('Stiahnúť PDF')}
              </DownloadPDFWrapper>
              <CopyWrapper onClick={() => this.createCartFromOrder(o.No)}>
                {copyOrderLoading ? <Loader /> : <Icon name="cart" size="l" />}
                <Spacer space={4} />
                {__('Vytvoriť kópiu')}
              </CopyWrapper>
            </PartWrapper>
          </Row>
          <Row>
            <PartWrapper>
              <PartTextLineRow>
                <PartTextLite>{__('Dátum vystavenia:')}</PartTextLite>
                <Spacer space={4} />
                <PartTextBold>
                  {formatDate(moment(o.Posting_Date), FORMAT_HUMANE_DATETIME)}
                </PartTextBold>
              </PartTextLineRow>

              <PartTextLineRow>
                <PartTextLite>{__('Spôsob platby:')}</PartTextLite>
                <Spacer space={4} />
                <PartTextBold />
              </PartTextLineRow>

              <PartTextLineRow>
                <PartTextLite>{__('Spôsob platby:')}</PartTextLite>
                <Spacer space={4} />
                <PartTextBold>{o.Payment_Method_Code}</PartTextBold>
              </PartTextLineRow>

              <PartTextLineRow>
                <PartTextLite>{__('Stav objednávky:')}</PartTextLite>
                <Spacer space={4} />
                <PartTextBold>{getOrderStatusByCode(o.Status)}</PartTextBold>
              </PartTextLineRow>
            </PartWrapper>

            <PartWrapper>
              <PartTextLineRow>
                <PartTextLite>{__('Číslo objednávky:')}</PartTextLite>
                <Spacer space={4} />
                <PartTextBold>{o.No}</PartTextBold>
              </PartTextLineRow>

              <PartTextLineRow>
                <PartTextLite>{__('Číslo objednávky z NAV:')}</PartTextLite>
                <Spacer space={4} />
                <PartTextBold />
              </PartTextLineRow>

              <PartTextLineRow>
                <PartTextLite>{__('Dátum a čas objednávky:')}</PartTextLite>
                <Spacer space={4} />
                <PartTextBold>
                  {formatDate(moment(o.Order_Date), FORMAT_HUMANE_DATETIME)}
                </PartTextBold>
              </PartTextLineRow>

              <PartTextLineRow>
                <PartTextLite>{__('Požadovaný dátum doručenia:')}</PartTextLite>
                <Spacer space={4} />
                <PartTextBold>
                  {formatDate(
                    moment(o.Requested_Delivery_Date),
                    FORMAT_HUMANE_DATETIME,
                  )}
                </PartTextBold>
              </PartTextLineRow>
            </PartWrapper>
          </Row>
        </HeaderWrapper>

        <HeaderWrapper>
          <Row>
            <PartWrapper style={{ marginBottom: rem(16) }}>
              <PartTextLineRow>
                <PartTextLite style={{ width: rem(200) }}>{`${__(
                  'Základ pre',
                )} ${vatRate}% DPH:`}</PartTextLite>
                <Spacer space={4} />
                <PartTextLite>
                  {formatPrice({
                    amount: totalPrice,
                    currency: o.VAT_Country_Region_Code === 'SK' ? 'EUR' : 'Kč',
                  })}
                </PartTextLite>
              </PartTextLineRow>
              <PartTextLineRow>
                <PartTextLite
                  style={{ width: rem(200) }}
                >{` ${vatRate}% DPH:`}</PartTextLite>
                <Spacer space={4} />
                <PartTextLite>
                  {formatPrice({
                    amount: vat,
                    currency: o.VAT_Country_Region_Code === 'SK' ? 'EUR' : 'Kč',
                  })}
                </PartTextLite>
              </PartTextLineRow>

              <PartTextLineRow>
                <PartTextLite style={{ width: rem(200) }}>
                  {__('Celkom spolu s DPH:')}
                </PartTextLite>
                <Spacer space={4} />
                <PartTextLite>
                  {formatPrice({
                    amount: totalPriceVat,
                    currency: o.VAT_Country_Region_Code === 'SK' ? 'EUR' : 'Kč',
                  })}
                </PartTextLite>
              </PartTextLineRow>

              <PartTextLineRow>
                <PartTextBold style={{ width: rem(200) }}>
                  {__('Celkom spolu k úhrade:')}
                </PartTextBold>
                <Spacer space={4} />
                <PartTextBold>
                  {formatPrice({
                    amount: totalPriceVat,
                    currency: o.VAT_Country_Region_Code === 'SK' ? 'EUR' : 'Kč',
                  })}
                </PartTextBold>
              </PartTextLineRow>
            </PartWrapper>
          </Row>
        </HeaderWrapper>
        <OrderRows
          rows={o.SalesLines.WS_Sales_Order_Line}
          location={this.props.location}
          history={this.props.history}
          firm={o.VAT_Country_Region_Code}
        />
      </MainContainer>
    );
  }
}

OrderDetail.propTypes = {
  location: PropTypes.shape.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(OrderDetail);



// WEBPACK FOOTER //
// ./src/Containers/Shop/Orders/Detail/index.jsx